module.exports = __webpack_public_path__ + "img/beauty-garden-gold.7915964e.png";